import React, {useState} from "react";
import {CircularProgress, IconButton, TextField} from "@mui/material";
import {Edit as EditIcon, RemoveCircle as RemoveIcon} from "@mui/icons-material";
import {UserAvatar} from "@atttomyx/react-components";
import {nodeService} from "../../services";
import {forms, objects, strings} from "@atttomyx/shared-utils";

const NodeForm = (props) => {
    const { snackbar, nodeId, data, onChange : onSync, } = props;
    const [ uploading, setUploading ] = useState(false);

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = strings.isNotBlank(modified.firstName) && strings.isNotBlank(modified.lastName);

        onSync(modified);
    };

    const uploadImage = (event) => {
        const file = event.target.files[0];

        setUploading(true);

        const success = (imageUrl) => {
            setUploading(false);
            onChange("imageUrl", imageUrl);
        };

        const failure = (err) => {
            setUploading(false);
            snackbar.setError(err);
        };

        nodeService.uploadImage(nodeId, file, success, failure);
    };

    const removeImage = () => {
        onChange("imageUrl", null);
    };

    return <div className="node-form">
        {nodeId ? <div className="field">
            {uploading ?
                <CircularProgress size="40px"/> :
                <>
                    <UserAvatar
                        user={data}
                        size="large"
                        mode="no-title"
                    />
                    <IconButton
                        color="secondary"
                        title="Remove image"
                        disabled={!data.imageUrl}
                        onClick={removeImage}
                    >
                        <RemoveIcon/>
                    </IconButton>
                    <input
                        hidden
                        accept="image/*"
                        id="node-file"
                        type="file"
                        onChange={uploadImage}
                    />
                    <label htmlFor="node-file">
                        <IconButton
                            color="primary"
                            title="Upload image"
                            component="span"
                        >
                            <EditIcon/>
                        </IconButton>
                    </label>
                </>}
        </div> : null}
        <div className="field">
            <TextField
                required={true}
                label="First Name"
                type="text"
                value={forms.sanitizeValue(data.firstName)}
                onChange={(event) => onChange("firstName", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                required={true}
                label="Last Name"
                type="text"
                value={forms.sanitizeValue(data.lastName)}
                onChange={(event) => onChange("lastName", event.target.value)}
            />
        </div>
    </div>
};

export default NodeForm;
